import { useAuth } from "@/contexts/AuthContext";

/**
 * Single source of truth for whether the Admin Panel entry point should be
 * shown, and where it should point. Network admins only have the podcasts
 * surface, so they land on /admin/podcasts instead of the admin dashboard.
 */
export function useAdminPanelLink() {
  const { hasRole } = useAuth();
  const isAdmin = hasRole("admin");
  const isNetworkAdmin = hasRole("network_admin");
  const isStudioAdmin = hasRole("studio_admin");

  return {
    showAdminPanel: isAdmin || isNetworkAdmin || isStudioAdmin,
    adminPanelTo: isAdmin || isStudioAdmin ? "/admin" : "/admin/podcasts",
    isAdmin,
  };
}
